import React, { useEffect, useState } from "react";
import classes from "../customer.module.css";
import {
  Modal,
  Button,
  Typography,
  MenuItem,
  Switch,
  FormControlLabel,
} from "@mui/material";
import Box from "@mui/material/Box";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { useDispatch, useSelector } from "react-redux";
import successimage from "../../../../Assets/images/ILL_Sucess.png";
import { updateCustomerSubscription } from "../../../../Redux/actions/customerActions";
import { fetchSubscriptions } from "../../../../Redux/actions/subscriptionAction";

function EditSubscriptionModal({ subscription, customerId, sort, filters, handleClose }) {
  const dispatch = useDispatch();
  const rootRef = React.useRef(null);

  const { subscriptions: plans } = useSelector((state) => state.subscriptions);

  const [modalToggle, setModalToggle] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const currentPlanId =
    subscription?.subscription_id || subscription?.subscription_info?._id || "";

  const [planId, setPlanId] = useState(currentPlanId);
  const [endDate, setEndDate] = useState(
    subscription?.end_date ? moment(subscription.end_date).format("YYYY-MM-DD") : ""
  );
  const [noTeamMembers, setNoTeamMembers] = useState(
    subscription?.no_team_members ?? ""
  );
  const [planActive, setPlanActive] = useState(Boolean(subscription?.plan_active));

  useEffect(() => {
    // Full catalogue, not the default page-of-10 — this is a dropdown, not
    // a paginated list, and every existing screen that fills a plan select
    // (e.g. AddUserSubscription) uses the same limit=100 convention.
    dispatch(fetchSubscriptions(1, 100, "", "packageName-asc"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeModal = () => {
    setModalToggle(false);
    handleClose(false);
  };

  const handlePlanChange = (e) => {
    const newPlanId = e.target.value;
    setPlanId(newPlanId);
    const newPlan = (plans || []).find((p) => p._id === newPlanId);
    if (newPlan && newPlan.noOfTeamMembers) {
      setNoTeamMembers(newPlan.noOfTeamMembers);
    }
  };

  const handleSubmit = () => {
    setError("");
    setSubmitting(true);

    const payload = {
      endDate,
      noTeamMembers: Number(noTeamMembers),
      planActive,
    };
    if (planId && planId !== currentPlanId) {
      payload.planId = planId;
    }

    dispatch(
      updateCustomerSubscription(
        subscription._id,
        payload,
        customerId,
        sort,
        filters,
        () => {
          setSubmitting(false);
          setSuccess(true);
        },
        (message) => {
          setSubmitting(false);
          setError(message || "Something went wrong. Please try again.");
        }
      )
    );
  };

  return (
    <div>
      <Modal
        open={modalToggle}
        aria-labelledby="server-modal-title"
        data-testid="edit_subscription_modal"
        aria-describedby="server-modal-description"
        sx={{
          display: "flex",
          height: "max-content",
          marginTop: 10,
          justifyContent: "center",
        }}
        container={() => rootRef.current}
      >
        <Box
          sx={{
            position: "relative",
            bgcolor: "background.paper",
            borderRadius: 1,
            boxShadow: (theme) => theme.shadows[5],
          }}
          style={{ width: "min(92vw, 420px)", height: "auto" }}
        >
          <Button
            variant="text"
            sx={{ minWidth: "unset" }}
            className={classes.closebtn}
            onClick={closeModal}
          >
            <MdClose />
          </Button>
          {!success && (
            <div className={classes.AddMemberHeading}>
              <Typography>Edit Subscription</Typography>
            </div>
          )}
          {!success ? (
            <ValidatorForm
              useref="form"
              onSubmit={handleSubmit}
              className={classes.formContainer}
            >
              <div className={classes.depFormContainer}>
                <div>
                  <div className="mt-3 mb-3">
                    <Typography className={classes.form_lable}>Plan*</Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: "100%",
                      }}
                      select
                      value={planId}
                      onChange={handlePlanChange}
                      fullWidth
                      size="small"
                      validators={["required"]}
                      errorMessages={["Plan is required"]}
                    >
                      {(plans || []).map((plan) => (
                        <MenuItem key={plan._id} value={plan._id}>
                          {plan.packageName}
                        </MenuItem>
                      ))}
                    </TextValidator>
                  </div>
                </div>
                <div>
                  <div className="mb-3">
                    <Typography className={classes.form_lable}>End Date*</Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                      fullWidth
                      size="small"
                      validators={["required"]}
                      errorMessages={["End date is required"]}
                    />
                  </div>
                </div>
                <div>
                  <div className="mb-3">
                    <Typography className={classes.form_lable}>
                      Number of Seats*
                    </Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      value={noTeamMembers}
                      onChange={(e) => setNoTeamMembers(e.target.value)}
                      fullWidth
                      size="small"
                      validators={["required", "minNumber:1"]}
                      errorMessages={[
                        "Seat count is required",
                        "Seat count must be at least 1",
                      ]}
                    />
                  </div>
                </div>
                <div>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={planActive}
                        onChange={(e) => setPlanActive(e.target.checked)}
                      />
                    }
                    label="Plan Active"
                  />
                </div>
                {error && (
                  <Typography style={{ color: "#BA1221", fontSize: 13 }}>
                    {error}
                  </Typography>
                )}
                <div className={"addMemberModalbtnSection"}>
                  <Button
                    variant="contained"
                    type="submit"
                    fullWidth
                    disabled={submitting}
                    className={`mb-4`}
                  >
                    {submitting ? "Saving..." : "Submit"}
                  </Button>
                </div>
              </div>
            </ValidatorForm>
          ) : (
            <div className={classes.addMembersuccess}>
              <img src={successimage} alt="Success logo" width={200} height={200} />
              <Typography className={classes.successMainText}>
                Subscription Updated Successfully
              </Typography>
              <Typography className={classes.successSubText}>
                Your changes to the subscription have been saved.
              </Typography>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default EditSubscriptionModal;
